<div class="modal-content">
  <form [formGroup]="formGroup" (submit)="onSubmit($event)">
    <div class="modal-header">
      <h4 class="modal-title" id="modal-basic-title">Upload Patient Consult Note</h4>
      <button type="button" class="btn-close" aria-label="Close" (click)="onCloseClick()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <div class="mb-2">
        Upload a consult note for the following patient and prescriber.
      </div>

      <div class="row mb-2">
        <div class="col-auto">
          <strong>CE-PATIENT</strong>
          <app-patient-name
            [patient]="capture.patient"
            [sourcePatient]="capture.sourcePatient"
            [canViewPatient]="canViewPatient" />
        </div>

        <div class="col-auto">
          <strong>RX-PRESCRIBER</strong>
          <app-prescriber-name [provider]="capture.provider" [linkToProvider]="true" />
          @if (capture.clientAffiliatedPrescriber) {
            <span class="client-affiliated-prescriber">
              Client Affiliated Prescriber
            </span>
          }
        </div>
      </div>

      <div class="offices-container">
        <table class="table table-sm table-fixed-header">
          <thead>
            <tr>
              <th>
                Office
              </th>
              <th>
                Provider Fax Status
              </th>
              <th>
                Patient Provider Fax Status
              </th>
            </tr>
          </thead>
          <tbody>
            @if (!loadingProviderOffices && !loadingPatientPrescriberOffices) {
              @for (providerOffice of providerOffices; track providerOffice; let i = $index) {
                <tr>
                  <td>
                    <div class="form-check">
                      <label for="office{{providerOffice.office.id}}">
                        <input
                          type="radio"
                          class="form-check-input"
                          id="office{{providerOffice.office.id}}"
                          formControlName="officeId"
                          [value]="providerOffice.office.id" />
                        <app-office [office]="providerOffice.office" />
                      </label>
                    </div>
                  </td>
                  <td>
                    <label for="office{{providerOffice.office.id}}">
                      {{ keyedProviderOfficeStatusOptions[providerOffice.status]?.display }}
                    </label>
                  </td>
                  <td>
                    <label for="office{{providerOffice.office.id}}">
                      {{ patientPrescriberOfficeStatus(providerOffice) }}
                    </label>
                  </td>
                </tr>
              }
            }
            @if (loadingProviderOffices || loadingPatientPrescriberOffices) {
              <tr>
                <td colspan="99">
                  <div><mat-spinner diameter="30" /></div>
                </td>
              </tr>
            }
            @if (!loadingProviderOffices && providerOffices.length === 0) {
              <tr>
                <td colspan="99">
                  <div class="text-danger">
                    Provider does not have any offices assigned.
                  </div>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>

      <div class="mb-1">
        <label for="sourceSelect">Source:</label>
        <select class="form-select" id="sourceSelect" formControlName="source">
          @for (source of sourceOptions; track source.value) {
            <option [value]="source.value">{{ source.display }}</option>
          }
        </select>
      </div>

      <div>
        <label>File</label>
      </div>

      <div>
        <input
          id="fileInput"
          [accept]="fileType"
          type="file"
          class="form-control"
          required
          [disabled]="fileUploadDisabled()"
          (change)="onFileChange($event)" />
      </div>

      @if (errorMessage) {
        <div class="mt-2 alert alert-danger">
          {{ errorMessage }}
        </div>
      }

      <div class="modal-footer">
        @if (uploading) {
          <mat-spinner diameter="30" />
        }

        <button
          type="submit"
          class="btn btn-primary"
          [disabled]="!formValid() || uploading">
          Save
        </button>

        <button
          type="button"
          class="btn btn-secondary"
          (click)="onCloseClick()"
          [disabled]="uploading">
          Cancel
        </button>
      </div>
    </div>
  </form>
</div>
